/**
 * Display helpers for the Lift report (backend: services/attribution/lift).
 */

/** Read a dotted path like 'initial.cvr' off a row. */
export function valueAt(row, path) {
  return path.split('.').reduce((value, key) => (value == null ? value : value[key]), row)
}

/** Rows sorted by a dotted path; nulls always last, whichever direction. */
export function sortLiftRows(rows, path, direction = 'desc') {
  const sign = direction === 'desc' ? -1 : 1
  return [...(rows || [])].sort((a, b) => {
    const x = valueAt(a, path)
    const y = valueAt(b, path)
    if (x == null && y == null) return 0
    if (x == null) return 1
    if (y == null) return -1
    if (typeof x === 'string' || typeof y === 'string') return sign * String(x).localeCompare(String(y))
    return sign * (x - y)
  })
}

/**
 * 'up' | 'down' | 'flat' | null. Only a significant lift gets a direction: a
 * 2.0x on twelve people is noise and is shown as such.
 */
export function liftTone(side) {
  if (!side || side.lift == null || !side.people) return null
  if (!side.significant) return 'flat'
  return side.lift > 1 ? 'up' : 'down'
}

/** The next level down from a row, or null at the bottom. */
export function drillFrom(groupBy, row) {
  if (groupBy === 'channel') return { groupBy: 'campaign', channel: row.channel, campaign: null, label: row.label }
  if (groupBy === 'campaign') return { groupBy: 'content', channel: row.channel, campaign: row.campaign_key, label: row.label }
  return null
}

export const pct = value => (value == null ? '—' : `${value.toFixed(1)}%`)
export const times = value => (value == null ? '—' : `${value.toFixed(2)}×`)
export const count = value => (value == null ? '—' : value.toLocaleString())
export const dollars = value => (value == null ? '—' : `$${Math.round(value).toLocaleString()}`)
